export function createDivOutside(): HTMLDivElement {
    const elementRenderImages = document.createElement('div')
    elementRenderImages.style.height = '1px'
    elementRenderImages.style.width = '1px'
    elementRenderImages.style.position = 'abosulte'    
    elementRenderImages.style.overflow = 'hidden'
    document.body.append(elementRenderImages)
    return elementRenderImages
}
